import script from "./DesignRibbon.vue?vue&type=script&setup=true&lang=js"
export * from "./DesignRibbon.vue?vue&type=script&setup=true&lang=js"

import "./DesignRibbon.vue?vue&type=style&index=0&id=57889514&lang=scss"

const __exports__ = script;

export default __exports__